import { schema } from 'normalizr'

const pauseReasonSchema = new schema.Entity('pauseReasons', {}, { idAttribute: 'pause_reason_id' })

export default [pauseReasonSchema]
